import TabbedPanel, { TabDefinition } from 'toolkit/tabs/tabbedPanel';
import { UserDto } from '@act/shared/data-transfer-objects';
import MemberFeed from 'react-components/member-feed/member-feed';
import { Badge, Box, Typography } from '@mui/material';
import { goalsTrackingSelectors } from 'redux/slices/goalsTracking.slice';
import { IconLibrary } from '@act/storybook';
import GoalsContent from 'react-components/goals/GoalsContent';

export interface GoalsFeedProps {
  member: UserDto;
}

const GoalsFeed = ({ member }: GoalsFeedProps) => {
  const goalsCount =
    goalsTrackingSelectors.useSelectAggregatedGoalsForMember(member?.id)
      ?.inProgress.length || 0;

  const tabDefinitions: TabDefinition[] = [
    {
      key: 'activity',
      label: (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconLibrary iconName="CalendarDots" />
          <Typography variant="titleMedium">Activity</Typography>
        </Box>
      ),
      component: <MemberFeed memberId={member?.id} />,
    },
    {
      key: 'goals',
      label: (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconLibrary iconName="CheckCircle" />
          <Typography variant="titleMedium">Goals</Typography>
          {goalsCount > 0 && (
            <Badge
              badgeContent={goalsCount}
              color="neutral"
              sx={{ marginLeft: '8px', flexShrink: 0 }}
            />
          )}
        </Box>
      ),
      component: <GoalsContent selectedMember={member} />,
    },
  ];

  return <TabbedPanel tabDefinitions={tabDefinitions} shouldEvenflow />;
};

export default GoalsFeed;
